module.exports = __webpack_public_path__ + "img/logo_linkedin.b907a96a.svg";